var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50049 1C2.84364 1 1.50049 2.34315 1.50049 4V15C1.50049 16.6569 2.84364 18 4.50049 18V20.5858C4.50049 21.9191 5.58137 23 6.9147 23C7.55499 23 8.16906 22.7456 8.62181 22.2929L13.2076 17.7071C13.5981 17.3166 13.5981 16.6834 13.2076 16.2929C12.8171 15.9024 12.1839 15.9024 11.7934 16.2929L7.2076 20.8787C7.12992 20.9564 7.02456 21 6.9147 21C6.68594 21 6.50049 20.8146 6.50049 20.5858V17C6.50049 16.4477 6.05277 16 5.50049 16H4.50049C3.94821 16 3.50049 15.5523 3.50049 15V4C3.50049 3.44772 3.94821 3 4.50049 3H20.5005C21.0528 3 21.5005 3.44772 21.5005 4V10C21.5005 10.5523 21.9482 11 22.5005 11C23.0528 11 23.5005 10.5523 23.5005 10V4C23.5005 2.34315 22.1574 1 20.5005 1H4.50049ZM19.5005 13C20.0528 13 20.5005 13.4477 20.5005 14V16H22.5005C23.0528 16 23.5005 16.4477 23.5005 17C23.5005 17.5523 23.0528 18 22.5005 18H20.5005V20C20.5005 20.5522 20.0528 21 19.5005 21C18.9482 21 18.5005 20.5522 18.5005 20V18H16.5005C15.9482 18 15.5005 17.5523 15.5005 17C15.5005 16.4477 15.9482 16 16.5005 16H18.5005V14C18.5005 13.4477 18.9482 13 19.5005 13Z",
    fill: "#5F6365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 13C20.0523 13 20.5 13.4477 20.5 14V16H22.5C23.0523 16 23.5 16.4477 23.5 17C23.5 17.5523 23.0523 18 22.5 18H20.5V20C20.5 20.5522 20.0523 21 19.5 21C18.9477 21 18.5 20.5522 18.5 20V18H16.5C15.9477 18 15.5 17.5523 15.5 17C15.5 16.4477 15.9477 16 16.5 16H18.5V14C18.5 13.4477 18.9477 13 19.5 13Z",
    fill: "#FF5A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/newChatIcon.bba719d550a1e2377df5c70faded60b4.svg";
export { ForwardRef as ReactComponent };